import type { Fragment } from '../translations';

export const shell: Fragment = {
  fr: {
    'shell.search': 'Rechercher…',
    'shell.collapse': 'Réduire',
    'shell.adminBadge': 'Admin',
    'shell.myProfile': 'Mon profil',
    'profile.title': 'Menu du profil',
    'profile.menuAria': 'Menu du profil',
    'shell.impersonating': 'Vous voyez l\'application comme {name} (par {by})',
    'shell.stopImpersonating': 'Arrêter',
    'shell.group.suivi': 'Suivi',
    'shell.group.processus': 'Processus',
    'shell.nav.home': 'Mon travail',
    'shell.nav.governance': 'Gouvernance',
    'shell.nav.observe': 'Observation',
    'shell.nav.repository': 'Répertoire',
    'shell.nav.tickets': 'Tickets',
    'shell.nav.admin': 'Administration',
    'shell.nav.cdeProcess': 'Comment travaille le CdE',
    'shell.title.home': 'Mon travail',
    'shell.title.governance': 'Gouvernance',
    'shell.title.observe': 'Observation',
    'shell.title.repository': 'Répertoire des processus',
    'shell.title.tickets': 'Tickets',
    'shell.title.admin': 'Administration',
    'shell.title.process': 'Processus',
    'shell.title.cde-process': 'Comment travaille le CdE',
    'shell.title.profile': 'Mon profil',
    'shell.unsavedTitle': 'Modifications non enregistrées',
    'shell.unsavedMessage': 'Vous avez des modifications non enregistrées. Les abandonner ?',
    'shell.unsavedConfirm': 'Abandonner',
  },
  en: {
    'shell.search': 'Search…',
    'shell.collapse': 'Collapse',
    'shell.adminBadge': 'Admin',
    'shell.myProfile': 'My profile',
    'profile.title': 'Profile menu',
    'profile.menuAria': 'Profile menu',
    'shell.impersonating': 'Viewing as {name} (by {by})',
    'shell.stopImpersonating': 'Stop',
    'shell.group.suivi': 'Tracking',
    'shell.group.processus': 'Processes',
    'shell.nav.home': 'My work',
    'shell.nav.governance': 'Governance',
    'shell.nav.observe': 'Observation',
    'shell.nav.repository': 'Repository',
    'shell.nav.tickets': 'Tickets',
    'shell.nav.admin': 'Administration',
    'shell.nav.cdeProcess': 'How the CdE works',
    'shell.title.home': 'My work',
    'shell.title.governance': 'Governance',
    'shell.title.observe': 'Observation',
    'shell.title.repository': 'Process repository',
    'shell.title.tickets': 'Tickets',
    'shell.title.admin': 'Administration',
    'shell.title.process': 'Process',
    'shell.title.cde-process': 'How the CdE works',
    'shell.title.profile': 'My profile',
    'shell.unsavedTitle': 'Unsaved changes',
    'shell.unsavedMessage': 'You have unsaved changes. Discard them?',
    'shell.unsavedConfirm': 'Discard',
  },
};
